import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../material/material.module';
import { CmlDropDownComponent } from './cml-dropdown-component';
import {MatTooltipModule} from "@angular/material/tooltip";



@NgModule({
  declarations: [
    CmlDropDownComponent
  ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        MatTooltipModule
    ],
  exports: [
    CmlDropDownComponent
  ]
})
export class CmlDropDownModule { }
